import LyCascaderCheck from './src/index.vue'

LyCascaderCheck.install = function (Vue) {
    Vue.component(LyCascaderCheck.name, LyCascaderCheck)
}

export default LyCascaderCheck



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/cascader-check/index.js
// module id = null
// module chunks = 